import {Component, inject} from '@angular/core';
import {
  PageHeaderComponent
} from '../../../../../../nter-ui-kit/src/lib/webkit/components/page-header/page-header.component';
import {AsyncPipe, NgForOf, NgIf, NgSwitch, NgSwitchCase} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressBar} from '@angular/material/progress-bar';
import {MatSelectModule} from '@angular/material/select';
import {LoadingService} from '@ui-kit/utils/service/loading.service';
import {FormsModule} from '@angular/forms';
import {MatOptionModule} from '@angular/material/core';
import {MRIBulkDownloadComponent} from '@features/transactions/external-accounts/mri/mri-bulk-download.component';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-retailer-external-software-statements',
  templateUrl: './retailer-external-software-statements.component.html',
  imports: [
    PageHeaderComponent,
    AsyncPipe,
    MatFormFieldModule,
    MatOptionModule,
    MatProgressBar,
    MatSelectModule,
    FormsModule,
    NgForOf,
    NgSwitch,
    NgIf,
    NgSwitchCase,
    MRIBulkDownloadComponent
  ],
  standalone: true
})
export class RetailerExternalSoftwareStatementsComponent {
  reloadSubject: Subject<void> = new Subject<void>();
  months = [
    {value: 1, name: 'January'}, {value: 2, name: 'February'},
    {value: 3, name: 'March'}, {value: 4, name: 'April'},
    {value: 5, name: 'May'}, {value: 6, name: 'June'},
    {value: 7, name: 'July'}, {value: 8, name: 'August'},
    {value: 9, name: 'September'}, {value: 10, name: 'October'},
    {value: 11, name: 'November'}, {value: 12, name: 'December'}
  ];
  years: number[] = [];
  softwares = [
    'MRI'
  ];
  selectedMonth: number | null = null;
  selectedYear: number | null = null;
  selectedSoftware: string | null = null;
  private _loader = inject(LoadingService);
  protected loading$ = this._loader.loading$;

  constructor() {
    this.years = Array.from({length: 2050 - 2020 + 1}, (_, i) => 2020 + i);
  }

  checkReload(): void {
    if (this.selectedMonth && this.selectedYear && this.selectedSoftware) {
      this.reloadSubject.next();
    }
  }
}
